import { AGlobalConfig, ATeacher } from 'kuaidong-api'
import { AppUtil, CanvasPoster, VueUtil } from 'kuaidong-lib'
export class DownloadService {
  static async buildBase64QrCodeUrl(
    scene: string,
    options: { width: number; logo?: string; logoWidth?: number; noLogo?: boolean; baseUrl?: string },
    qd?: string
  ): Promise<string> {
    const url = await this.buildDownloadUrl(scene, { baseUrl: options.baseUrl }, qd)
    const result = await CanvasPoster.createQRCodeImageURL(
      url,
      VueUtil.getActualPx(options.width),
      options.noLogo ? undefined : options.logo,
      // undefined,
      VueUtil.getActualPx(options.logoWidth || 10)
    )
    return result
  }

  static async buildDownloadUrl(
    scene: string,
    cfg?: { baseUrl?: string; query?: any; keep_long_url?: boolean },
    qd?: string
  ): Promise<string> {
    const shareCode = await ATeacher.getShareCode(scene)
    // eslint-disable-next-line prefer-const
    let url = AppUtil.buildDownloadUrl(
      qd || '',
      shareCode,
      cfg
        ? {
            baseUrl: cfg.baseUrl,
            query: cfg.query,
          }
        : undefined
    )
    // 生成短地址
    if (!cfg || !cfg.keep_long_url) {
      url = await AGlobalConfig.buildShortUrl(url)
    }
    return url
  }
}
